/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { ColumnRange } from './ColumnRange';
import { LineRange } from './LineRange';
import { QualityCommentSeverity } from './QualityCommentSeverity';
const BaseAutoTestQualityCommentParser = 
/* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['severity', QualityCommentSeverity],
    ['code', /* #__PURE__ */ parsers.maybeNull(codecString)],
    ['origin', codecString],
    ['msg', codecString],
    ['line', LineRange],
    ['column', ColumnRange],
]));
export class BaseAutoTestQualityComment extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BaseAutoTestQualityCommentParser.decode(input).map(res => new BaseAutoTestQualityComment(res));
    }
    static unsafeDecode(input) {
        return BaseAutoTestQualityComment.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseAutoTestQualityCommentParser.encode(data);
    }
    static schema() {
        return BaseAutoTestQualityCommentParser.schema();
    }
}
